import React from 'react';
import {
    StyledSubmittedContainer,
    StyledSubmittedTitle,
    StyledSubmittedDesc,
} from './RCX.styled';
import Submitted from '../assets/submitted';

export const SubmittedSplash = ({ title, desc }: { title: string, desc: string }) => {
    return (
        <StyledSubmittedContainer>
            <Submitted />
            <StyledSubmittedTitle>{title}</StyledSubmittedTitle>
            <StyledSubmittedDesc>{desc}</StyledSubmittedDesc>
        </StyledSubmittedContainer>
    );
};
